module.exports = __webpack_public_path__ + "static/media/logo-linkedin.23400d52.svg";